/* Tanboutique "Sunset Clay" — gedrag (Lou & Lou, okt 2026). Geen dependencies. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.body.classList.add('tb-body');

  /* ---------- header: hoogte + schaduw ---------- */
  function setHeaderH() {
    var h = $('.tb-header-wrap');
    if (h) document.documentElement.style.setProperty('--tb-header-h', h.offsetHeight + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);
  window.addEventListener('scroll', function () {
    var hd = $('.tb-header');
    if (hd) hd.classList.toggle('is-scrolled', window.scrollY > 8);
  }, { passive: true });

  /* ---------- drawers (menu / filters) ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input'); if (f) f.focus();
  }
  function closeDrawers() {
    $$('.tb-drawer.is-open, .tb-filters.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tb-open]');
    if (o) { e.preventDefault(); var id = o.getAttribute('data-tb-open'); var t = document.getElementById(id);
      if (t && t.classList.contains('tb-filters')) { t.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; } else openDrawer(id); return; }
    if (e.target.closest('[data-tb-close]') || e.target.classList.contains('tb-drawer__overlay')) { e.preventDefault(); closeDrawers(); }
    var s = e.target.closest('[data-tb-search-toggle]');
    if (s) { e.preventDefault(); var box = $('.tb-search'); if (box) { box.classList.toggle('is-open'); var i = box.querySelector('input'); if (i && box.classList.contains('is-open')) i.focus(); } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); var b = $('.tb-search'); if (b) b.classList.remove('is-open'); } });

  /* ---------- carousels ---------- */
  function initCarousel(c) {
    var track = c.querySelector('.tb-carousel__track'); if (!track || c.dataset.tbReady) return;
    c.dataset.tbReady = '1';
    var prev = c.querySelector('[data-tb-prev]'), next = c.querySelector('[data-tb-next]');
    var bar = c.querySelector('.tb-progress span');
    function step() { var item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 20 : 300; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    function upd() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var vis = track.clientWidth / track.scrollWidth;
      bar.style.width = Math.max(vis * 100, 8) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * (100 / Math.max(vis, .08) - 100) : 0) + '%)';
    }
    track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* ---------- tabs ---------- */
  function initTabs(w) {
    if (w.dataset.tbReady) return; w.dataset.tbReady = '1';
    var tabs = $$('[role="tab"]', w);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = true; });
        t.setAttribute('aria-selected', 'true');
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) { p.hidden = false; window.dispatchEvent(new Event('resize')); }
      });
    });
  }

  /* ---------- reveal ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function init(scope) {
    $$('.tb-carousel', scope).forEach(initCarousel);
    $$('[data-tb-tabs]', scope).forEach(initTabs);
    $$('.tb-reveal', scope).forEach(function (el) { if (io && !(window.Shopify && window.Shopify.designMode)) io.observe(el); else el.classList.add('is-in'); });
    $$('[data-tb-pdp]', scope).forEach(initPdp);
    $$('[data-tb-readmore]', scope).forEach(function (b) {
      var t = document.getElementById(b.getAttribute('data-tb-readmore'));
      if (!t || t.scrollHeight <= t.clientHeight + 4) { b.hidden = true; return; }
      b.addEventListener('click', function () { var c = t.classList.toggle('is-clamped'); b.textContent = c ? b.dataset.more : b.dataset.less; });
    });
  }
  window.Shopify = window.Shopify || {};
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); setHeaderH(); });

  /* ---------- winkelmand (AJAX) ---------- */
  function updateCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-tb-cartcount]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }
  var toastTimer;
  function toast(item) {
    var t = $('#tb-toast'); if (!t) return;
    var img = t.querySelector('img');
    if (item && item.image && img) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120'; img.hidden = false; } else if (img) img.hidden = true;
    var n = t.querySelector('[data-tb-toast-name]'); if (n && item) n.textContent = item.product_title;
    t.classList.add('is-visible'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches('[data-tb-atc]')) return;
    e.preventDefault();
    var btns = $$('button[type="submit"]', f); btns.forEach(function (b) { b.disabled = true; b.dataset.label = b.dataset.label || b.innerHTML; b.innerHTML = '…'; });
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Toevoegen mislukt'); return; }
        toast(res.j); updateCount();
      })
      .catch(function () { f.submit(); })
      .finally(function () { btns.forEach(function (b) { b.disabled = false; b.innerHTML = b.dataset.label; }); });
  });

  /* ---------- productpagina ---------- */
  function money(cents) {
    var fmt = (window.TB && TB.moneyFormat) || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function initPdp(w) {
    if (w.dataset.tbReady) return; w.dataset.tbReady = '1';
    var dataEl = w.querySelector('[data-tb-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var main = w.querySelector('.tb-gallery__main');
    var thumbs = $$('.tb-gallery__thumb', w);
    var dots = $$('.tb-gallery__dots button', w);

    function goTo(i, smooth) {
      if (!main) return;
      var s = main.children[i]; if (!s) return;
      main.scrollTo({ left: s.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    dots.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (main) main.addEventListener('scroll', function () {
      var i = Math.round(main.scrollLeft / main.clientWidth); mark(i);
    }, { passive: true });

    /* qty */
    $$('[data-tb-qty]', w).forEach(function (q) {
      var input = q.querySelector('input');
      q.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var v = parseInt(input.value, 10) || 1; v = b.dataset.dir === '-' ? Math.max(1, v - 1) : v + 1; input.value = v;
      });
    });

    /* varianten */
    var form = w.querySelector('[data-tb-atc]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    function selected() { return $$('.tb-variant', w).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function onChange() {
      var sel = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      $$('.tb-variant', w).forEach(function (fs, i) { var lab = fs.querySelector('legend span'); if (lab) lab.textContent = sel[i] || ''; });
      // beschikbaarheid markeren
      $$('.tb-variant', w).forEach(function (fs, idx) {
        $$('.tb-variant__opt', fs).forEach(function (o) {
          var val = o.querySelector('input').value;
          var test = sel.slice(); test[idx] = val;
          var m = variants.find(function (x) { return x.options.every(function (op, i) { return op === test[i]; }); });
          o.classList.toggle('is-unavailable', !m || !m.available);
        });
      });
      var atc = $$('[data-tb-atc-btn]');
      if (!v) { atc.forEach(function (b) { b.disabled = true; b.textContent = 'Niet beschikbaar'; }); return; }
      if (idInput) idInput.value = v.id;
      atc.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? b.dataset.add : b.dataset.soldout; });
      var p = w.querySelector('[data-tb-price]');
      if (p) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        p.classList.toggle('tb-price--sale', !!sale);
        p.innerHTML = '<span class="tb-price__now">' + money(v.price) + '</span>' + (sale ? ' <s>' + money(v.compare_at_price) + '</s> <span class="tb-pinfo__save">-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>' : '');
      }
      var st = w.querySelector('[data-tb-stock]');
      if (st) { st.className = 'tb-stock' + (v.available ? '' : ' tb-stock--out'); st.textContent = v.available ? st.dataset.in : st.dataset.out; }
      if (v.featured_media_index !== null && v.featured_media_index !== undefined) goTo(v.featured_media_index);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
    }
    $$('.tb-variant input', w).forEach(function (i) { i.addEventListener('change', onChange); });
    if (variants.length > 1) onChange();

    /* sticky add-to-cart (mobiel) */
    var sticky = document.querySelector('.tb-sticky-atc');
    var buy = w.querySelector('.tb-buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-visible', on); document.body.classList.toggle('tb-sticky-on', on); }).observe(buy);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  /* ---------- keuzehulp ---------- */
  function initGuide(g) {
    if (g.dataset.tbReady) return; g.dataset.tbReady = '1';
    var tabs = $$('.tb-guide__tabs [role="tab"]', g), panels = $$('.tb-guide__panel', g);
    var res = g.querySelector('.tb-guide__result'), hint = g.querySelector('[data-tb-hint]'), best = 0;
    function show(i) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      var t = tabs[i]; if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    g.addEventListener('change', function (e) {
      if (!e.target.closest('.tb-guide__opt')) return;
      var c1 = g.querySelector('[data-q="1"] input:checked'), c2 = g.querySelector('[data-q="2"] input:checked');
      var a1 = c1 ? c1.value : null, a2 = c2 ? c2.value : null, top = -1;
      panels.forEach(function (p, i) {
        var q1 = (p.dataset.q1 || '').split(','), q2 = (p.dataset.q2 || '').split(','), sc = 0;
        if (a1 && q1.indexOf(a1) > -1) sc += 2;
        if (a2 && q2.indexOf(a2) > -1) sc += 3;
        if (sc > top) { top = sc; best = i; }
      });
      panels.forEach(function (p, i) { var b = p.querySelector('.tb-guide__badge'); if (b) b.hidden = !(i === best && top > 0); });
      tabs.forEach(function (t, i) { t.classList.toggle('is-reco', i === best && top > 0); });
      if (top > 0) show(best);
      if (a1 && a2 && top > 0 && res) {
        res.hidden = false; if (hint) hint.hidden = true;
        res.querySelector('.tb-guide__result-name').textContent = panels[best].dataset.name;
        res.querySelector('.tb-guide__result-tag').textContent = panels[best].dataset.tag;
      }
    });
    var go = g.querySelector('.tb-guide__go');
    if (go) go.addEventListener('click', function () { show(best); var t = g.querySelector('.tb-guide__types'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }
  $$('[data-tb-guide]').forEach(initGuide);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-tb-guide]', e.target).forEach(initGuide); });

  /* ---------- zwevende app-knoppen netjes plaatsen ---------- */
  function tidyWhatsapp() {
    var wa = document.querySelector('gty-whatsapp-chat-button');
    if (!wa || !wa.shadowRoot || wa.shadowRoot.getElementById('tb-wa')) return !!(wa && wa.shadowRoot && wa.shadowRoot.getElementById('tb-wa'));
    var side = (window.TB && TB.whatsappSide) || 'right';
    var st = document.createElement('style'); st.id = 'tb-wa';
    st.textContent = side === 'right'
      ? '.gty-wacb-wrapper{left:auto!important;right:var(--tb-fab-x,20px)!important;bottom:var(--tb-fab-y,20px)!important;transition:bottom .3s}'
      : '.gty-wacb-wrapper{right:auto!important;left:calc(var(--tb-fab-x,20px) + 132px)!important;bottom:var(--tb-fab-y,20px)!important;transition:bottom .3s}';
    wa.shadowRoot.appendChild(st);
    return true;
  }
  var waTries = 0, waTimer = setInterval(function () { if (tidyWhatsapp() || ++waTries > 40) clearInterval(waTimer); }, 500);

  /* ---------- filters: automatisch verzenden ---------- */
  document.addEventListener('change', function (e) {
    var f = e.target.closest('[data-tb-filterform]');
    if (f && window.matchMedia('(min-width: 990px)').matches && e.target.type !== 'number') f.submit();
    var s = e.target.closest('[data-tb-sort]');
    if (s) { var u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); window.location.href = u.toString(); }
  });
})();